import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import './styles.scss';

const ProgressBox = ({ currentQuestionIdx, totalQuestions }) => {
    return (
        <div className='progress-container'>
            {i18n.t('engagement.x_out_of_y_answered', { x: currentQuestionIdx, y: totalQuestions })}
            <div className='progress-bar'>
                <div className='inner-bar' style={ { width: `${ (currentQuestionIdx / totalQuestions) * 100 }%` } } />
            </div>
        </div>
    );
};

ProgressBox.propTypes = {
    currentQuestionIdx: PropTypes.number,
    totalQuestions: PropTypes.number
};

ProgressBox.defaultProps = {
    currentQuestionIdx: 0,
    totalQuestions: 0
};

export default ProgressBox;
